module.exports = __webpack_public_path__ + "static/media/aluWall.9557be92.jpeg";